export const transformBarChartData = (section) => {
  const labels = section?.values?.map((v) => v.displayName);
  const data = section?.values?.map((v) => v.count);
  const filterInfo = section?.values?.map((v) => v.filters);
  return { labels, datasets: [{ label: section?.displayName, data, filterInfo}] };
};

export const transformGroupedBarChartData = (section) => {
  const labels = section?.values?.map((v) => v.displayName);
  const categories =
    section?.values?.[0]?.values?.map((v) => v.displayName) || [];
  const datasets = categories.map((cat) => ({
    label: cat,
    data: section.values.map((g) => {
      const found = g.values.find((v) => v.displayName === cat);
      return found?.count ?? 0;
    }),
    filterInfo: section.values.map((g) => {
      const found = g.values.find((v) => v.displayName === cat);
      return found?.filters ?? "";
    }),
  }));
  return { labels, datasets };
};

export const transformPieChartData = (section) => {
  const labels = section?.values?.map((v) => v.displayName);
  console.log("Labels in pie chart data", labels);
  const datasets = section?.values?.map((v) => v.count);
  console.log("Data in pie chart data", datasets);
  const filterInfo = section?.values?.map((v) => v.filters);
  return { labels, datasets, filterInfo };
};


export function formatDisplayNameWithNewline(displayName?: string): string {
  return displayName ? displayName.replace(" ", "\n") : "";
}
